import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, } from "@mui/material";
import { useCallback, useState } from "react";
import moment, { Moment } from "moment";
import PaperDraggable from "../../../../../../../../components/PaperDraggable";
import DateComIntervalo from "../../../../../../../../components/DateComIntervalo";

export default function PeriodoApuracao({
    open,
    defaultValue,
    onClose,
    onSubmitFiltros,
}: PeriodoApuracaoProps) {

    const [periodo, setperiodo] = useState<TPeriodo>({ inicio: moment(defaultValue.inicio), fim: moment(defaultValue.fim) });

    const handleChangePeriodo = (name: keyof TPeriodo, value: any) => {
        setperiodo(prevState => ({ ...prevState, [name]: value }));
    }

    const handleSubmit = useCallback(() => {
        onSubmitFiltros({inicio: periodo.inicio.format('YYYY-MM-DD'), fim: periodo.fim.format('YYYY-MM-DD')});
        onClose();
    }, [periodo, onClose, onSubmitFiltros]);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={'xs'}
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
            fullWidth
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Período de apuração</DialogTitle>
            <DialogContent>
                <Box mt={1}>
                    <DateComIntervalo
                        data={{
                            inicial: (periodo.inicio),
                            final: (periodo.fim)
                        }}
                        onChangeData={(data) => {
                            handleChangePeriodo("inicio", data.inicial)
                            handleChangePeriodo("fim", data.final)
                        }}
                        datePickerView={['year', 'month', 'day']}
                        formatString="DD/MM/YYYY"
                        labelInput="Período"
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Box display={'flex'} gap={2}>
                    <Button variant="outlined" onClick={onClose}>
                        Fechar
                    </Button>
                    <Button variant="contained" color="primary" onClick={handleSubmit}>
                        Alterar
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    )
}

interface PeriodoApuracaoProps {
    open: boolean
    defaultValue: {
        inicio: string;
        fim: string;
    }
    onClose: () => void
    onSubmitFiltros: (value: any) => void
}

type TPeriodo = {
    inicio: Moment;
    fim: Moment;
}
